import React from 'react';
import { Alert, Card, Typography } from 'antd';
import { CompanyBillingTab } from '../CompanyManagement/CompanyBillingTab';
import { CompanyAdminGate } from './CompanyAdminGate';

const { Title, Text } = Typography;

export const CompanyAdminBillingPage: React.FC = () => (
  <CompanyAdminGate>
    {(target) => (
      <Card>
        <Title level={3}>Billing</Title>
        <Text type="secondary">Billing account for {target.companyName}.</Text>
        <Alert
          style={{ marginTop: 16 }}
          type="info"
          showIcon
          message="Card capture is not on this form"
          description="Status and billing contact fields save through the company billing account API. Creating a billing account when none exists is refused by that API. Stripe Checkout is a separate product flow and is not started from this page."
        />
        <div style={{ marginTop: 16 }}>
          <CompanyBillingTab companyId={target.companyId} />
        </div>
      </Card>
    )}
  </CompanyAdminGate>
);

export default CompanyAdminBillingPage;
